import { Box, HStack, IconButton, Stack, Text } from '@chakra-ui/react';
import { t } from '@lingui/core/macro';
import { NodeViewWrapper, type NodeViewProps } from '@tiptap/react';
import { X } from 'lucide-react';
import { iconSize } from '@duke-hq/ui/constants/scalable';
import { testIds } from './testIds';

/**
 * The two blocks the send path fills in, as the editor shows them. A node view
 * so removing one is a button rather than a guess; the document is unaffected.
 */
export function EmailBlockNodeView({
  node,
  deleteNode,
  selected,
}: NodeViewProps): React.ReactElement {
  const isButton = node.type.name === 'cta';

  return (
    <NodeViewWrapper>
      <HStack
        my={2}
        px={3}
        py={2}
        gap={2}
        bg="bg.subtle"
        borderRadius="md"
        borderWidth="1px"
        borderColor={selected ? 'brand.500' : 'transparent'}
        justifyContent="space-between"
        contentEditable={false}
      >
        <Stack gap={0}>
          <Text fontSize="sm">{isButton ? node.attrs.label : t`Course details`}</Text>
          <Text fontSize="xs" color="fg.muted">
            {isButton
              ? t`Button. Its address is filled in when the email is sent.`
              : t`The dates and study schedule, filled in when the email is sent.`}
          </Text>
        </Stack>
        <Box>
          <IconButton
            aria-label={isButton ? t`Remove this button` : t`Remove the course details`}
            icon={<X size={iconSize.sm} />}
            size="xs"
            variant="ghost"
            onClick={deleteNode}
            data-testid={testIds.removeBlock}
          />
        </Box>
      </HStack>
    </NodeViewWrapper>
  );
}
